import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DeliveryAddressService } from '@checkout/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { DeviceService } from '@shared/services';
import { Address } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { SdvorDeliveryAddressDialogModalComponent } from '../delivery-address-dialog/delivery-address-dialog-modal/delivery-address-dialog-modal.component';

@Component({
  selector: 'sd-delivery-address-list',
  templateUrl: './delivery-address-list.component.html',
  styleUrls: ['./delivery-address-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryAddressListComponent implements OnInit, OnDestroy {
  addressList$: Observable<Address[]>;
  addressListLength$: Observable<number>;
  isMobile$: Observable<boolean>;
  loading$: Observable<boolean>;

  subscription = new Subscription();
  iconType = CUSTOM_ICON_TYPE;

  constructor(
    private deliveryAddressService: DeliveryAddressService,
    private modalService: ModalService,
    private deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.addressList$ = this.deliveryAddressService.addressList$;
    this.addressListLength$ = this.deliveryAddressService.addressListLength$;
    this.isMobile$ = this.deviceService.isMobileSmDown$;
    this.loading$ = this.deliveryAddressService.loading$;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openModal(): void {
    this.modalService.open(SdvorDeliveryAddressDialogModalComponent, {
      centered: true,
      size: 'xl',
    });
  }
}
